import { IBaseResponse } from 'shared/typings';

export enum EAdspaceStatus {
	NOT_VERIFIED = 'NotVerified',
	VERIFYING = 'Verifying',
	VERIFIED = 'Verified',
	DECLINED = 'Declined',
	DEACTIVATED = 'Deactivated',
	CREATING = 'Creating',
}

export enum EAdspaceGroup {
	WEBSITE = 'Website',
	INFLUENCER = 'Influencer',
	SOFTWARE = 'Software',
	ADTECH = 'AdTech',
}

export interface IAdspace {
	adspace_id: string;
	group: EAdspaceGroup;
	status: EAdspaceStatus;
	name: string;
	platforms: string;
	country_codes: string;
	categories: string;
	description: string;
	created_at: string;
	updated_at: string;
	has_sources: boolean;
	source_can_be_created: boolean;
	mitgo_verify_url: string;
	mitgo_adspace_url: string;
}

export type TAdspaceList = IBaseResponse<IAdspace[] | null>;
